import { useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import { useContext } from "react";

function useBlocker(blocker, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;
    const replace = navigator.replace;

    navigator.push = (...args) => {
      if (blocker()) {
        return;
      }
      push(...args);
    };

    navigator.replace = (...args) => {
      if (blocker()) {
        return;
      }
      replace(...args);
    };

    return () => {
      navigator.push = push;
      navigator.replace = replace;
    };
  }, [navigator, blocker, when]);
}

export function usePrompt(message, when = true) {
  useBlocker(() => !window.confirm(message), when);
}

export default usePrompt;